import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './stil.css';
import App from './App.tsx';
import { Absturzfang } from './teile/Absturzfang.tsx';
import { keinZoom } from './teile/keinzoom.ts';
import { alsApp } from './teile/alsapp.ts';

/* VOR DEM ZEICHNEN UND NICHT IN EINEM BAUTEIL.
   ---------------------------------------------------------------------------
   Marvin, 22.09.2026: „Die mobile Version ist immernoch zoombar, was zu
   Propellern führt." Die Riegel hängen am Fenster und nicht an einem Baum,
   der beim Wechsel der Seite neu gebaut wird - ein Zuhörer, der mit dem
   Bildschirm kommt und geht, ist genau dann weg, wenn jemand zwischen 2
   Seiten kneift. */
keinZoom();

/* DAS INSTALLIEREN AUF DEM RECHNER. Marvin, 22.09.2026: „ich will die
   webseite auf dem pc als app installieren." Was dafür nötig ist, steht in
   `teile/alsapp.ts` - hier steht nur der Aufruf. */
alsApp();

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <Absturzfang>
      <App />
    </Absturzfang>
  </StrictMode>
);
